<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <total-fleet-create-or-update v-model="fleet" :errors="errors"></total-fleet-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    name="total-fleet"
                    :add-callback="createNew"
                    :fields="fields"
                    :buttons="buttons"
                    pagination="server"
                    search></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import FuelOperationApi from '@/api/fuel-operations'
import TotalFleetCreateOrUpdate from './components/TotalFleetCreateOrUpdate.vue'

export default {
    components:{
        BCard,
        TotalFleetCreateOrUpdate
    },
    data(){
        return{
            editing:false,
            errors:{},
            loading:false,
            fleet:{
                Id:0,
                FleetCode:null,
                Name:null,
                Description:null,
                OriginalName:null
            },
            fields:[
                { name:"Filo Kodu",key:"FleetCode", thClass:"w-25",tdClass:"text-right",sortable:true,},
                { name:"Filo Adı",key:"Name", thClass:"w-25",sortable:true},
                { name:"Kaynak Filo Adı",key:"OriginalName", thClass:"w-25",sortable:true},
                { name:"Açıklama",key:"Description", thClass:"w-25",sortable:true,}
                
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ]
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.fleet.Id = 0
            this.fleet.Name = null
            this.fleet.FleetCode = null
            this.fleet.Description = null
            this.fleet.OriginalName = null
           
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.fleet.Id = item.Id
            this.fleet.Name = item.Name
            this.fleet.FleetCode = item.FleetCode
            this.fleet.Description = item.Description
            this.fleet.OriginalName= item.OriginalName
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            FuelOperationApi.TotalFleet.CreateOrUpdate(this.editing,this.fleet)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.clearForm()
                    this.$hideModal('create-or-update')
                }
                this.$result(res)
                this.loading = false
            })
        },
        provider(data){
            return FuelOperationApi.TotalFleet.Table(data)
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} ana grubu silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    FuelOperationApi.TotalFleet.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>